<template>
    <div>
        <edit-carousel-modal
            v-model="editCarouselDialog"
            :modelProp="carouselSelected"
            @successful-carousel-save="refreshCarouselsData"
            @successful-carousel-delete="refreshCarouselsData"
            :constants="constants"
            :nextPriorityProp="nextPriorityProp"
        >
        </edit-carousel-modal>

        <edit-event-modal
            v-model="editEventDialog"
            :modelProp="eventSelected"
            @successful-event-save="refreshEventsData"
            @successful-event-delete="refreshEventsData"
            :constants="constants"
            :eventPrioritiesProp="eventPrioritiesProp"
        >
        </edit-event-modal>

        <edit-show-modal
            v-model="editShowDialog"
            :modelProp="showSelected"
            @successful-show-save="refreshShowsData"
            @successful-show-delete="refreshShowsData"
            :constants="constants"
        >
        </edit-show-modal>

        <div class="tw-flex tw-flex-col tw-gap-4 tw-p-1">
            <internal-table-section :section-title="titleCarousels" button-text="Add Banner" @button-clicked="addCarouselItem" class="tw-w-full">
                <v-card id="table_card" class="d-flex flex-row container-fluid" flat>
                    <v-card-text class="pa-0 d-block">
                        <v-layout child-flex>
                            <smart-table
                                id="carousels_table"
                                class="row-pointer"
                                endpoint="carousels.list"
                                :headers="headersCarousels"
                                :search="searchCarousels"
                                flat
                                @click:row="showCarouselItem"
                                ref="carousels_list"
                            >
                                <template v-slot:item.image_desktop="{ item }">
                                    <v-img
                                        v-if="item.image_desktop"
                                        max-height="75"
                                        max-width="100"
                                        :src="'/storage/carousels/' + item.image_desktop"
                                    ></v-img>
                                </template>
                            </smart-table>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </internal-table-section>
            <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-4">
                <internal-table-section :section-title="titleEvents" button-text="Add Event" @button-clicked="addEvent" class="tw-w-full lg:tw-w-1/2">
                    <v-card id="table_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <v-layout child-flex>
                                    <smart-table
                                        id="events_table"
                                        class="row-pointer"
                                        endpoint="events.list"
                                        :headers="headersEvents"
                                        :search="searchEvents"
                                        flat
                                        @click:row="showEvent"
                                        ref="events_list"
                                    >
                                        <template v-slot:item.image="{ item }">
                                            <v-img
                                                v-if="item.image"
                                                max-height="75"
                                                max-width="100"
                                                :src="'/storage/events/' + item.image"
                                            ></v-img>
                                        </template>
                                    </smart-table>
                                </v-layout>
                        </v-card-text>
                    </v-card>
                </internal-table-section>
                <internal-table-section :section-title="titleShows" button-text="Add Show" @button-clicked="addShow" class="tw-w-full lg:tw-w-1/2">
                    <v-card id="table_card" class="d-flex flex-row container-fluid" flat>
                        <v-card-text class="pa-0 d-block">
                            <v-layout child-flex>
                                    <smart-table
                                        id="shows_table"
                                        class="row-pointer"
                                        endpoint="shows.list"
                                        :headers="headersShows"
                                        :search="searchShows"
                                        flat
                                        @click:row="showShow"
                                        ref="shows_list"
                                    >
                                        <template v-slot:item.image="{ item }">
                                            <v-img
                                                v-if="item.image"
                                                max-height="75"
                                                max-width="100"
                                                :src="'/storage/shows/' + item.image"
                                            ></v-img>
                                        </template>
                                    </smart-table>
                                </v-layout>
                        </v-card-text>
                    </v-card>
                </internal-table-section >
            </div>
        </div>
    </div>

</template>

<script>
    import EditCarouselModal from "@/Modals/EditCarouselModal"
    import EditEventModal from "@/Modals/EditEventModal"
    import EditShowModal from "@/Modals/EditShowModal"
    import SmartTable from "@/Generic/SmartTable";
    import InternalHeader from "@/Generic/InternalHeader";
    import InternalTableSection from "@/Generic/InternalTableSection";

    export default {
        name: "WebsiteContentHomePage",
        components: {
            EditCarouselModal,
            EditEventModal,
            EditShowModal,
            SmartTable,
            InternalHeader,
            InternalTableSection,
        },
        props: {
            'nextPriorityProp': {
                type: Number,
            },
            'eventPrioritiesProp': {
                type: Array,
            },
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                titleCarousels: 'Carousel Images',
                editCarouselDialog: false,
                searchCarousels: null,
                carouselSelected: {},

                titleEvents: 'News & Events',
                editEventDialog: false,
                searchEvents: null,
                eventSelected: {},

                titleShows: 'Latest Shows',
                editShowDialog: false,
                searchShows: null,
                showSelected: {},
            }
        },
        mounted() {
            //
        },
        computed: {
            headersCarousels() {
                return [
                    {value: 'image_desktop',    text: 'Image',    align: `start`, sortable: false,   filterable: false,   search: null, optional: false, width: '180px' },
                    {value: 'title',            text: 'Title',    align: `start`, sortable: true,    filterable: false,   search: null, optional: false, },
                    {value: 'image_color',      text: 'Color',    align: `start`, sortable: true,    filterable: false,   search: null, optional: false, },
                ]
            },

            headersEvents() {
                return [
                    {value: 'image',        text: 'Image',    align: `start`, sortable: false,   filterable: false,   search: null, optional: false, width: '180px' },
                    {value: 'date',         text: 'Date',     align: `start`, sortable: true,    filterable: false,   search: this?.filters?.date, optional: false },
                    {value: 'title',        text: 'Title',    align: `start`, sortable: true,    filterable: false,   search: this?.filters?.title, optional: false, },
                    {value: 'target',       text: 'Target',   align: `start`, sortable: true,    filterable: false,   search: this?.filters?.target, optional: false, },
                    {value: 'access',       text: 'Access',   align: `start`, sortable: true,    filterable: false,   search: null, optional: false, },
                ]
            },

            headersShows() {
                return [
                    {value: 'image',        text: 'Image',    align: `start`, sortable: false,   filterable: false,   search: null, optional: false, width: '180px' },
                    {value: 'title',        text: 'Title',    align: `start`, sortable: true,    filterable: false,   search: this?.filters?.title, optional: false, },
                    {value: 'link',       text: 'IMDB link',   align: `start`, sortable: true,    filterable: false,   search: null, optional: false, },
                ]
            },

        },
        methods: {
            // Carousels
            refreshCarouselsData() {
                this.$refs.carousels_list.refreshList()
            },
            showCarouselItem(item) {
                this.carouselSelected = item
                this.editCarouselDialog = true
            },
            addCarouselItem() {
                this.carouselSelected = null
                this.editCarouselDialog = true
            },

            // Events
            refreshEventsData() {
                this.$refs.events_list.refreshList()
            },
            showEvent(item) {
                this.eventSelected = item
                this.editEventDialog = true
            },
            addEvent() {
                this.eventSelected = null
                this.editEventDialog = true
            },

            // Shows
            refreshShowsData() {
                this.$refs.shows_list.refreshList()
            },
            showShow(item) {
                this.showSelected = item
                this.editShowDialog = true
            },
            addShow() {
                this.showSelected = null
                this.editShowDialog = true
            },
        }
    }
</script>
